<template>
  <div class="who">
    <img class="who__line" src="@images/whoLine.png" alt="line">
    <div class="container">
      <div class="who__wrapper">
        <h2 class="who__title">{{ t('home.who.title') }}</h2>
        <p class="who__text">{{ t('home.who.text') }}</p>
        <div class="who__block">
          <div class="who__block-item">{{ t('home.who.item1') }}</div>
          <div class="who__block-item">{{ t('home.who.item2') }}</div>
          <div class="who__block-item">{{ t('home.who.item3') }}</div>
          <div class="who__block-item">{{ t('home.who.item4') }}</div>
          <div class="who__block-item">{{ t('home.who.item5') }}</div>
          <div class="who__block-item">{{ t('home.who.item6') }}</div>
        </div>
      </div>
    </div>
    <img class="who__image" src="@images/whoImage.png" alt="image">
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.who {
  position: relative;

  &__line {
    position: absolute;
    top: -14px;
    left: 0;
  }

  &__wrapper {
    padding-block: 150px 100px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__title {
    color: #F3F3F3;
    font-size: 64px;
    font-weight: 700;
  }

  &__text {
    width: 815px;
    color: #F3F3F3;
    font-size: 20px;
    line-height: 150%;
  }

  &__block {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(3, 280px);
    gap: 24px;

    &-item {
      border-radius: 10px;
      border: 2px solid #F00;
      padding-block: 10px;
      display: grid;
      place-items: center;

      text-align: center;
      color: #F3F3F3;
      font-size: 20px;
    }
  }

  &__image {
    position: absolute;
    top: 50px;
    right: 0;
    width: 550px;
  }
}

@media (max-width: 1680px) {
  .who {
    &__text {
      width: 700px;
      font-size: 18px;
    }

    &__block {
      grid-template-columns: repeat(3, 230px);

      &-item {
        font-size: 18px;
      }
    }
  }
}

@media (max-width: 1300px) {
  .who {
    &__image {
      width: 400px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

@media (max-width: 1150px) {
  .who {
    &__title {
      font-size: 42px;
    }

    &__text {
      width: 500px;
      font-size: 16px;
    }

    &__block {
      grid-template-columns: repeat(3, 175px);

      &-item {
        font-size: 14px;
      }
    }
  }
}

@media (max-width: 950px) {
  .who {
    &__wrapper {
      padding-block: 75px 50px;
    }

    &__image {
      width: 300px;
    }

    &__text {
      width: 350px;
      font-size: 14px;
    }

    &__block {
      grid-template-columns: repeat(2, 175px);
    }
  }
}

@media (max-width: 650px) {
  .who {
    &__image {
      width: 200px;
      top: 25px;
      transform: unset;
    }

    &__wrapper {
      padding-block: 100px 50px;
    }

    &__text {
      margin-top: 50px;
    }

    &__block {
      justify-content: center;
    }
  }
}

@media (max-width: 450px) {
  .who {
    &__wrapper {
      padding-block: 200px 50px;
    }

    &__image {
      top: 15px;
      width: 150px;
    }

    &__title {
      text-align: center;
    }

    &__text {
      width: 100%;
      text-align: center;
      margin-top: 0;
    }

    &__block {
      grid-template-columns: repeat(2, 150px);

      &-item {
        font-size: 12px;
      }
    }
  }
}
</style>